import {http} from "@/helpers/http-helper";

export const deleteCampaignType = (campaignTypeId) => {
  return new Promise( (resolve, reject) => {
    const url = 'campaign-type/' + campaignTypeId;
    http.delete(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCampaignTypes = () => {
  return new Promise( (resolve, reject) => {
    const url = 'campaign-types';
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPublicCampaignTypes = () => {
  return new Promise( (resolve, reject) => {
    const url = 'public/campaign-types';
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//
// export const getSearchCampaigns = (params) => {
//   return new Promise((resolve, reject) => {
//     const url = 'campaigns/search';
//     http.get(url, params)
//       .then((response) => {
//         if (response.status === 200) {
//           resolve(response.data);
//         } else {
//           reject(response.status);
//         }
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };
